import { render } from "./oficialiaArchivados.vue?vue&type=template&id=656c6744&scoped=true"
import script from "./oficialiaArchivados.vue?vue&type=script&lang=js"
export * from "./oficialiaArchivados.vue?vue&type=script&lang=js"

import "./oficialiaArchivados.vue?vue&type=style&index=0&id=656c6744&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656c6744"]])

export default __exports__